import { createSelector } from 'reselect'
import _ from 'lodash';

export const locales = (state) => state.general.base ? state.general.base.locales : [];
export const languages = (state) => state.general.base ? state.general.base.languages : [];
export const countries = (state) => state.general.base ? state.general.base.countries : [];




// WEBPACK FOOTER //
// ./src/storeState/general/selectors.js